export default "__VITE_ASSET__DMeYQ8Go__"